export default __webpack_public_path__ + "static/media/roadmap-head-shark-10.8238c3c4.png";